let element = null;
let text = null;

const createToast = () => {
  element = document.createElement('div');
  element.classList.add('toast');

  text = document.createElement('div');
  text.classList.add('toast__text');
  element.appendChild(text);

  element.addEventListener("click", () => {
    Toast.close();
  })
}

let timer = null;

/**
 * @typedef { Object } ToastConfig
 * @property { string } place
 * @property { string } state
 * @property { number|string } delay
 */

class Toast {
  static close() {
    clearTimeout(timer);

    element.remove();
    element.classList.remove('shown');
  }

  /**
   * 
   * @param { string } message 
   * @param { ToastConfig } config 
   */
  static open(message, config = {}) {
    if (!element) createToast();

    text.innerHTML = message;

    element.setAttribute('data-placement', config.place || 'top-right');
    element.setAttribute('data-state', config.state || 'default');

    document.body.appendChild(element);
    element.classList.add('shown');

    if (config.delay !== "infinity") {
      timer = setTimeout(() => {
        Toast.close();
      }, config.delay || 1000 * 5);
    }
  }
}

export default Toast;
